import UserMyTicketsPage from 'modules/support/my-tickets/flow/userTickets/UserMyTicketPage';

const MyTicketsPage = () => {
  return <UserMyTicketsPage />;
};

export default MyTicketsPage;
